import script from "./EmployeesView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesView.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesView.vue?vue&type=style&index=0&id=6247cc39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6247cc39"]])

export default __exports__